import { PartnerFlow } from "@remi/enums/partner-flow";
import { isOneOf } from "@remi/ts-utils";

import { hasCapability, type User } from "../base";
import { SUNRUN_ORG_ID } from "../constant-users";

export const hic = {
  create: (user: User, partnerFlow: PartnerFlow) => {
    if (!isOneOf(partnerFlow, [PartnerFlow.SUNRUN_PRE_PTO, PartnerFlow.SUNRUN_PRE_PTO_STRATEGIC_PARTNER])) {
      return false;
    }
    if (hasCapability(user, "hic.create")) {
      return true;
    }
    return user.person.organizationId === SUNRUN_ORG_ID;
  },
};
